export function findOrderIdx(orders, order) {
  for (let idx in orders) {
    const ord = orders[idx];
    if (ord.label === order.label) {
      return idx;
    }
  }
}

export function getLastRow(orders) {
  let higher = 0;
  for (let idx in orders) {
    const rowId = parseInt(orders[idx].rowId);

    if (rowId > higher) {
      higher = rowId;
    }
  }

  return higher;
}
